import { useEvidenceReview } from 'contexts/evidenceReview';
import PDFViewer from 'shell/components/PDFViewer';

const EvidencePDFViewer = (props) => {
    const review = useEvidenceReview();

    return (
        <PDFViewer
            {...props}
            autoScrollFirstHighlight={false}
            navigationRequest={review?.navigationRequest}
            onNavigationComplete={review?.completeNavigationRequest}
        />
    );
};

export default EvidencePDFViewer;
